var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddproduct = function SvgAddproduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBookPro-2017",
    transform: "translate(-44.000000, -328.000000)",
    fill: "#40A63B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,328 C59.5228475,328 64,332.477153 64,338 C64,343.522847 59.5228475,348 54,348 C48.4771525,348 44,343.522847 44,338 C44,332.477153 48.4771525,328 54,328 Z M54,332 C53.4477153,332 53,332.447715 53,333 L53,333 L53,337 L49,337 C48.4477153,337 48,337.447715 48,338 C48,338.552285 48.4477153,339 49,339 L49,339 L53,339 L53,343 C53,343.552285 53.4477153,344 54,344 C54.5522847,344 55,343.552285 55,343 L55,343 L55,339 L59,339 C59.5522847,339 60,338.552285 60,338 C60,337.447715 59.5522847,337 59,337 L59,337 L55,337 L55,333 C55,332.447715 54.5522847,332 54,332 Z",
    id: "Combined-Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddproduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addproduct.ef435687.svg";
export { ForwardRef as ReactComponent };